(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halal-business-blueprint"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ---- Year ---- */
  var yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  /* ---- Nav scroll shadow ---- */
  var nav = document.getElementById('nav');
  function onScrollNav() {
    if (window.scrollY > 12) nav.classList.add('scrolled');
    else nav.classList.remove('scrolled');
  }
  window.addEventListener('scroll', onScrollNav, { passive: true });
  onScrollNav();

  /* ---- Countdown (persistent target ~ 1d 18h from first visit) ---- */
  var KEY = 'rizq_launch_deadline';
  var deadline = parseInt(localStorage.getItem(KEY), 10);
  var now = Date.now();
  if (!deadline || isNaN(deadline) || deadline < now) {
    deadline = now + (42 * 60 * 60 * 1000); // 42 hours window
    localStorage.setItem(KEY, String(deadline));
  }
  var cd = document.getElementById('countdown');
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tickCountdown() {
    if (!cd) return;
    var diff = deadline - Date.now();
    if (diff < 0) diff = 0;
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    cd.innerHTML = '<b>' + pad(d) + '</b>d <b>' + pad(h) + '</b>h <b>' + pad(m) + '</b>m <b>' + pad(s) + '</b>s';
  }
  tickCountdown();
  setInterval(tickCountdown, 1000);

  /* ---- Live viewer count (gentle fluctuation) ---- */
  var vc = document.getElementById('viewerCount');
  var viewers = 14;
  setInterval(function () {
    var delta = Math.round((Math.random() - 0.45) * 3);
    viewers = Math.max(9, Math.min(27, viewers + delta));
    if (vc) vc.textContent = viewers;
  }, 4200);

  /* ---- Reveal on scroll ---- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('seen'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('seen'); });
  }

  /* ---- Progress bar fill on view ---- */
  var bar = document.querySelector('.progress-bar > i');
  if (bar && 'IntersectionObserver' in window) {
    var pio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          bar.style.width = (bar.getAttribute('data-progress') || '65') + '%';
          pio.disconnect();
        }
      });
    }, { threshold: 0.4 });
    pio.observe(bar);
  } else if (bar) {
    bar.style.width = (bar.getAttribute('data-progress') || '65') + '%';
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q');
    var a = item.querySelector('.faq-a');
    q.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function (o) {
        o.classList.remove('open');
        o.querySelector('.faq-a').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('open');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  /* ---- Sticky mobile CTA: show after hero, hide over offer/final ---- */
  var sticky = document.getElementById('stickyCta');
  var hero = document.querySelector('.hero');
  function onScrollSticky() {
    if (!sticky || !hero) return;
    var past = (window.scrollY > hero.offsetHeight * 0.7);
    var offer = document.getElementById('offer');
    var final = document.querySelector('.final');
    var overCta = false;
    [offer, final].forEach(function (sec) {
      if (!sec) return;
      var r = sec.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) overCta = true;
    });
    if (past && !overCta) sticky.classList.add('show');
    else sticky.classList.remove('show');
  }
  window.addEventListener('scroll', onScrollSticky, { passive: true });
  onScrollSticky();

  /* ---- Purchase notification toasts ---- */
  var stack = document.getElementById('toastStack');
  var PURCHASES = [
    { name: 'Ahmed', city: 'London', act: 'purchased the Blueprint', t: '2 hours ago' },
    { name: 'Fatima', city: 'Birmingham', act: 'joined today', t: 'just now' },
    { name: 'A brother', city: 'Dubai', act: 'enrolled', t: '5 hours ago' },
    { name: 'Yusuf', city: 'Manchester', act: 'purchased the Blueprint', t: '8 minutes ago' },
    { name: 'Aisha', city: 'Toronto', act: 'joined the community', t: '1 hour ago' },
    { name: 'A sister', city: 'Riyadh', act: 'got instant access', t: '23 minutes ago' },
    { name: 'Bilal', city: 'Leicester', act: 'purchased the Blueprint', t: '3 hours ago' },
    { name: 'Mariam', city: 'Abu Dhabi', act: 'enrolled today', t: 'just now' },
    { name: 'Omar', city: 'Bradford', act: 'joined the community', t: '12 minutes ago' }
  ];
  function initials(name) {
    if (name.indexOf('brother') > -1) return '🤍';
    if (name.indexOf('sister') > -1) return '🤍';
    return name.charAt(0);
  }
  var pIdx = 0;
  function showToast() {
    if (!stack || document.body.classList.contains('urgency-light')) return;
    var p = PURCHASES[pIdx % PURCHASES.length];
    pIdx++;
    var el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML =
      '<div class="t-av">' + initials(p.name) + '</div>' +
      '<div><div class="t-name">' + p.name + ' from ' + p.city + '</div>' +
      '<div class="t-act">' + p.act + '</div>' +
      '<div class="t-time"><span class="vdot"></span>' + p.t + ' · verified</div></div>';
    stack.appendChild(el);
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('in'); }); });
    setTimeout(function () {
      el.classList.remove('in');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 600);
    }, 5200);
  }
  // schedule recurring toasts
  setTimeout(function loop() {
    showToast();
    setTimeout(loop, 9000 + Math.random() * 7000);
  }, 5000);

  /* ---- Smooth-anchor offset handled by CSS scroll-behavior ---- */
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
